import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MixpanelService } from '../services/mixpanel.service';

@Injectable()
export class AnalyticsService {

  constructor(
    private router: Router,
    private mixpanel: MixpanelService
  ) {}

  // trackPageViews() {
  //   this.router.events.pipe(
  //     filter((event) => event instanceof NavigationEnd),
  //   ).subscribe(() => {

  //   });
  // }

  identify(userId: string, properties?: any) {
    this.mixpanel.identify(userId);
    if (properties) {
      this.mixpanel.setUserProperties(properties);
    }
  }
}
